import {CanActivate, Router} from "@angular/router";
import {Injectable} from "@angular/core";
import {Auth} from "../app.auth";

@Injectable()
export class AuthenticationGuard implements CanActivate {
    constructor(
        private _router: Router,
        private _auth: Auth
    ) {}

    canActivate() {
        if ( this._auth.isAuthenticated ) {
            return true;
        }

        this._router.navigate(['/sign-in']);
        return false;
    }
}


// WEBPACK FOOTER //
// ./src/app/guards/authentication.guard.ts